import http from '../http';

const userApi = {
	auth(data) {
		return http.post('/user/auth', data);
	},
	register(data) {
		return http.post('/user/register', data);
	},
	forgotPassword(data) {
		return http.post('/user/forgot-password', data);
	},
	resetPassword(data) {
		return http.post('/user/reset-password', data);
	},
	favouriteArtwork(data) {
		return http.post('/user/favourite-artwork', data);
	}
}

const postsApi = {
	getArtworks(args) {
		return http.get('/artworks?' + $.param(args));
	}
}

export {
	userApi,
	postsApi
}